<template>
    <input type="range" v-bind="$attrs" v-model="rangeValue" class="accent-brand-500" />
</template>

<script setup lang="ts">
const rangeValue = defineModel({
    set(v: number | string) {
        return parseInt(v as string);
    },
    default: 0,
});
</script>
